import React, {memo} from "react";
import classNames from "classnames/bind";
import {ASSET_LIST_TYPE} from "components/Layout/constants";
import ListTypeItemThumbnail from "../ListTypeItemThumbnail";
import AssetItemThumbnail from "../AssetItemThumbnail";
import {ASSET_TYPE} from "utils";
import useHandleAssetInfo from "../hooks/useHandleAssetInfo";
import styles from "./index.module.scss";

const cn = classNames.bind(styles);

function UploadingThumbnail({data, listType, uploadProgress}) {
  const {handleAssetThumbnail} = useHandleAssetInfo();

  const isSoundOrVideo = data?.topCategory === ASSET_TYPE.VIDEO || data?.topCategory === ASSET_TYPE.SOUND;
  // [TEMP] - 에셋 업로드 시 피드백으 위한 임시 UI를 생성하는 부분. 관련 필드 변경으로 임시 주석
  return (
    <div className={cn("asset_wrapper", listType)}>
      {/* {listType === ASSET_LIST_TYPE.LIST && (
        <ListTypeItemThumbnail
          asset={data}
          thumbnail={handleAssetThumbnail(data)}
          duration={data?.duration}
          uploadProgress={uploadProgress}
        />
      )}
      {listType !== ASSET_LIST_TYPE.LIST && (
        <AssetItemThumbnail
          asset={data}
          thumbnail={data?.thumbnailUrl}
          duration={data?.duration}
          uploadProgress={uploadProgress}
          appearance={{
            listType,
            small: listType === ASSET_LIST_TYPE.WIDE,
            hasOverplayButton: isSoundOrVideo,
            singleText: data?.topCategory === ASSET_TYPE.MODEL,
          }}
        />
      )} */}
    </div>
  );
}

export default memo(UploadingThumbnail);
